import { Button, Text } from '@instamenu/ui-system-next';
import { backButtonStyles } from './back-button.css';
import { palette } from '@instamenu/ui-vanilla-extract';
import { ArrowLeft } from 'lucide-react';

export interface BackButtonProps {
  onClick?: () => void;
  css?: React.CSSProperties;
  label?: string;
}

export function BackButton({ onClick, label, css }: BackButtonProps) {
  return (
    <Button
      variant="text"
      size="xs"
      onClick={onClick}
      css={{ display: 'flex', alignItems: 'center', padding: 0, ...css }}
    >
      <ArrowLeft size={18} color={palette.gray900.toString()} />
      <Text className={backButtonStyles}>{label ?? 'Back'}</Text>
    </Button>
  );
}
